<template>
  <fragment>
    <div class="col-12 col-lg-8">
      <div class="dash-section contains-list">
        <div class="header mb-2">
          <div>
            <h2 class="title">
              Upcoming Wellbeing Workshops
            </h2>
          </div>
        </div>
        <div class="dash-sub-section mt-0">
          <list-skeleton
            v-if="workshopsReport.loading && !workshopsReport.hasNext"
            list-type="session"
          />
          <ul v-else class="dashboard-list">
            <li class="row header-labels sticky">
              <div class="col-8 subject">
                <div>Description</div>
              </div>
              <div class="col-4 data">
                <div>Remaining Slots</div>
                <div class="when-cell">When</div>
              </div>
            </li>
            <li v-if="workshopsReport.workshops.length === 0" class="empty">No Results</li>
            <li
              v-for="workshop in workshopsReport.workshops"
              :key="workshop.id"
              class="row"
              tabindex="0"
            >
              <div class="col-12 col-sm-8 subject">
                <div class="title">{{ workshop.topic }}</div>
                <div>{{ workshop.description }}</div>
              </div>
              <div class="col-12 col-sm-4 data">
                <transition name="update" mode="out-in">
                  <div :key="`${workshop.id}_app`" >
                    <em class="sr-only-sm-up">Remaining Slots</em>
                    {{ workshop.remainingSlots }}
                  </div>
                </transition>
                <transition name="update" mode="out-in">
                  <div class="when-cell" :key="`${workshop.id}_when`" >
                    <em class="sr-only-sm-up">When</em>
                    {{ workshopDate(workshop) }}
                  </div>
                </transition>
              </div>
            </li>
          </ul>
          <div v-if="displayLoadMoreButton" class="load-more">
            <button class="dash-button" @click="workshopsReport.fetch()">
              Load More Results
            </button>
          </div>
          <div v-if="workshopsReport.loading && workshopsReport.hasNext" class="list-progress-bar">
            <div class="value"></div>
            <span class="sr-only">loading</span>
          </div>

          <div
            v-if="workshopsReport.workshops.length > 0 && !workshopsReport.hasNext"
            class="end-of-list"
          >
            <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
            <p>All Results Loaded</p>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Skeleton from '../../Skeleton.vue'
import ListSkeleton from '../../ListSkeleton.vue';
import moment from 'moment';


export default {
  name: 'WorkshopsTab',

  components: {
    Skeleton,
    ListSkeleton
  },

  inject:['workshopsReport'],

  computed: {
    displayLoadMoreButton() {
      return this.$globals.isMobile
        && this.workshopsReport.hasNext
        && !this.workshopsReport.loading;
    }
  },

  created() {
    window.addEventListener('scroll', this.handleScroll, { once:true });
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, { once:true });
  },

  mounted(){
    this.workshopsReport.reset()
  },
  methods:{
    
    workshopDate(workshop){
      return moment(workshop.when).format('M/DD/yyyy [at] h:mma')
    },

    async handleScroll() {
      if(!this || !this.workshopsReport)
        return;

      const atBottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >=
        document.documentElement.offsetHeight * 0.8;
      
      if (!this.$globals.isMobile && atBottomOfWindow && this.workshopsReport.hasNext)
        await this.workshopsReport.fetch();

      window.addEventListener('scroll', this.handleScroll, { once:true });
    },
  },
};
</script>

<style lang="scss" scoped>
.dash-sub-section {
  border-top: 0px;
}
.dashboard-list li .subject {
  flex-direction: column;
  align-items: flex-start;

  .title {
    font-weight: 600;
    padding-bottom: 10px;
  }
}
.when-cell {
  padding-left: 20px;
}
.dash-section.contains-list {
  min-height: 350px;
}
</style>
